export default __webpack_public_path__ + "static/media/project5.4d2f7f2c.jpeg";